import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/solid';

type Props = {
    /** The heading to be displayed in bold on the card. */
    heading: React.ReactNode;
    /** The body to be displayed below the heading. */
    body: React.ReactNode;
};
const DropdownCard = (props: Props) => {
    const {
        heading,
        body,
    } = props;

    return (
        <div className='w-85 px-4 mr-8 py-2 text-left border-1-5 shadow-card
            border-card-normal rounded-md hover:border-card-hover active:shadow-none'>
            <Disclosure >
                {({ open }) => (
                    <>
                        <Disclosure.Button className='flex flex-row justify-between w-full'>
                            <span className='font-bold'>
                                {heading}
                            </span>
                            <ChevronUpIcon
                                className={`${
                                    open ? 'transform rotate-180' : ''
                                } w-5 h-5 text-gradients-primary-start`}
                            />
                        </Disclosure.Button>
                        {open && (
                            <>
                                <Disclosure.Panel>
                                    {body}
                                </Disclosure.Panel>
                            </>
                        )}
                    </>
                )}
            </Disclosure>
        </div>
    );
};

export default DropdownCard;